<template>
  <div>
    <b-modal
      v-model="removalAcceptance"
      :cancel-title="$t('general.no')"
      :ok-title="$t('general.yes')"
      centered
      size="sm"
      @cancel="removalAcceptance = false"
      @ok="deletionConfirmed"
    >
      <p>
        {{
          $t("toastification.areYouSureOfDeletion", {
            item: itemToDelete ? itemToDelete.title : "",
          })
        }}
      </p>
    </b-modal>

    <!--    <b-modal v-model="enableGrouping" centered hide-footer size="xl">-->
    <!--      <permission-group-modal :permissions="permissions" :formattedPermissions="formattedPermissions" :v="$v"-->
    <!--                              @groupCreated="groupCreated"></permission-group-modal>-->
    <!--    </b-modal>-->
    <!--    <div class="custom-search d-flex justify-content-start">-->
    <!--      <b-form-group>-->
    <!--        <div class="d-flex align-items-center">-->
    <!--          <label class="mr-1">{{ $t('general.search') }}</label>-->
    <!--          <b-form-input-->
    <!--              v-model="searchTerm"-->
    <!--              :placeholder=" $t('general.search')"-->
    <!--              class="d-inline-block"-->
    <!--              type="text"-->
    <!--              @input="searchParityType"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </b-form-group>-->
    <!--    </div>-->

    <div class="white-section mt-2">
      <b-row class="d-flex justify-content-end mb-2">
        <!--        <b-col class="d-flex justify-content-end" cols="1">-->
        <!--          <b-button-->
        <!--              size="sm"-->
        <!--              variant="info"-->
        <!--              @click="enableGrouping = true"-->

        <!--          >{{ $t("permissions.createPermissionsGroup") }}-->
        <!--          </b-button>-->
        <!--        </b-col>-->
        <b-col class="d-flex justify-content-end" cols="1">
          <b-button size="sm" to="/permissions/add" variant="primary"
            >{{ $t("general.add") }}
          </b-button>
        </b-col>
        <!--        <router-link tag="button" to="/permissions/add" class="btn btn-success">{{ $t('general.add') }}</router-link>-->
      </b-row>
      <!--      <div class="d-flex justify-content-end mb-2">-->
      <!--       -->
      <!--      </div>-->
      <!-- table -->
      <div class="mb-2">
        <!--        <v-tree ref="tree" :data='formattedPermissions' :halfcheck='true' :multiple="false" :tpl='tpl'-->
        <!--                class="permissions-tree"/>-->
        <b-col class="mb-2" cols="12">
          <!--      <v-treeview-->
          <!--          selectable-->
          <!--          :transition="true"-->
          <!--          rounded-->
          <!--          return-object-->
          <!--          item-key="_id"-->
          <!--          item-text="title"-->
          <!--          v-model="selectedPermissions"-->
          <!--          :items="formattedPermissions"-->

          <!--      ></v-treeview>-->
          <!--      <v-select-tree class="permissions-tree" ref="permissionsList" :scoped="true" :halfcheck="false" :pleasechoosetext="$t('permissions.permissionsList')"-->
          <!--                     :searchable="false" :multiple="true" :data='formattedPermissions'-->
          <!--      />-->

          <vue-good-table
            :columns="columns"
            :rows="formattedPermissions"
            class="permission-table permission-table-2"
            styleClass="vgt-table"
          >
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label === 'title'" class="text-nowrap">
                {{ $t("permissions.permissions") }}
              </span>
              <span v-else class="text-nowrap"> </span>
            </template>

            <!-- Slot: Table Row -->
            <template slot="table-row" slot-scope="props">
              <span
                v-if="props.column.field === 'title'"
                class="text-nowrap d-flex"
              >
                <!-- Column: Name -->
                <b-form-checkbox
                  v-if="$route.name !== 'managePermissions'"
                  :id="`checkbox-${props.row.key}`"
                  :value="props.row"
                  @change="permissionChecked($event, props.row)"
                >
                </b-form-checkbox>
                <!--        <span v-if="props.column.field === 'permissions'" class="text-nowrap">-->
                          <feather-icon
                            style="cursor: pointer;  color:#00cfe8"
                            size="16"
                            icon="Edit2Icon"
                            class="mr-50"
                            @click="editAPermission(props.row)"
                        />
                        <feather-icon
                            v-if="!props.row.children.length"
                            style="cursor: pointer"
                            size="16"
                            icon="TrashIcon"
                            class="mr-50"
                            @click="deleteAPermission(props.row)"
                        />
                        <span> {{ props.row.title }}</span>

                <!--        </span>-->
              </span>
              <span v-if="props.column.field === 'child'" class="text-nowrap">
                <!--          {{props.row.children}}-->
                <nested-table
                  :createFormattedPermission="createFormattedPermission"
                  v-if="props.row.children.length"
                  ref="nestedTable"
                  :childColumns="childColumns"
                  :children="props.row.children"

                ></nested-table>
              </span>
            </template>
            <div slot="emptystate"></div>
          </vue-good-table>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BCol,
  BRow,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import NestedTable from "@/components/NestedTable";
import { VSelectTree, VTree } from "vue-tree-halower";
import PermissionGroupModal from "@/components/permissions/PermissionGroupModal";

export default {
  components: {
    PermissionGroupModal,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BButton,
    BCol,
    BRow,
    VSelectTree,
    VTree,
    VueGoodTable,
    NestedTable,
  },
  data() {
    return {
      // selectedPermissions: [],
      // formattedPermissions: [],
      treeData: null,
      searchTerm: "",
      // enableGrouping: false,
      removalAcceptance: false,
      groupRemovalAcceptance: false,
      itemToDelete: null,
      columns: [
        {
          label: "title",
          field: "title",
          sortable: false,
        },
        {
          label: "child",
          field: "child",
          sortable: false,
        },
      ],
      childColumns: [
        {
          label: "title",
          field: "title",
          sortable: false,
        },
        {
          label: "child",
          field: "child",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    tpl(...args) {
      const { 0: node, 2: parent, 3: index } = args;
      let titleClass = node.selected
        ? "node-title node-selected"
        : "node-title";
      if (node.searched) titleClass += " node-searched";
      return (
        <span>
          <span
            class={titleClass}
            domPropsInnerHTML={node.title}
            onClick={() => {
              this.$refs.tree.nodeSelected(node);
            }}
          ></span>
          <feather-icon
            icon="TrashIcon"
            className="mr-50"
            onClick={() => this.deleteANode(node, parent, index)}
          />
        </span>
      );
    },
    deleteAPermission(permission) {
      this.itemToDelete = permission;
      this.removalAcceptance = true;


    },
    editAPermission(permission) {
      this.permissionToEdit = permission;
      this.$router.push({
        name: "editPermission",
        params: { permissionId: permission._id },

      });
    },
    // deleteAGroup(group) {
    //   // console.log(group)
    //   this.itemToDelete = group;
    //   this.groupRemovalAcceptance = true;
    // },
    deletionConfirmed() {
      this.$store
        .dispatch("permissions/deletePermission", this.itemToDelete._id)
        .then((res) => {
          
          // this.$refs.tree.delNode(node, parent, index)
          this.$bvToast.toast(this.$t("toastification.deletionSucceed"), {
            // title: this.$t('toastification.success'),
            variant: "success",
            solid: true,
          });
          this.permissions = this.permissions.filter((p) => {
            return p._id !== res._id;
          });
          // console.log(this.permissions);
          this.createFormattedPermission(this.permissions);
          this.removalAcceptance = false;
        });
    },
    async asyncLoad(node) {
      this.$set(node, "loading", true);
      let pro = new Promise((resolve) => {
        setTimeout(resolve, 2000, ["async node1", "async node2"]);
      });
      this.$refs.tree1.addNodes(node, await pro);
      this.$set(node, "loading", false);
    },
    removeItem(index) {
      this.parityTypes.splice(index, 1);
    },
    createFormattedPermission(res) {
      let list = _.cloneDeep(res);
      var map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i]._id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
          // if you have dangling branches check that map[node.parentId] exists
          // console.log(node);

          // list[map[node.parentId]].children = [];
          // list[map[node.parentId]].id = list[map[node.parentId]]._id;
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      // console.log(roots);
      this.formattedPermissions = roots;
      // console.log(this.formattedPermissions);
    },
  },

  computed: {
    ...mapGetters({
      // permissions: 'permissions/permissions',
      // permissionGroups: 'permissions/permissionGroups',
    }),
    permissions: {
      get() {
        return this.$store.getters["permissions/permissions"];
      },
      set(permissions) {
        this.$store.commit("permissions/SET_PERMISSIONS", permissions);
      },
    },
    formattedPermissions: {
      get() {
        return this.$store.getters["permissions/formattedPermissions"];
      },
      set(permissions) {
        this.$store.commit(
          "permissions/SET_FORMATTED_PERMISSIONS",
          permissions
        );
      },
    },
    permissionGroups: {
      get() {
        return this.$store.getters["permissions/permissionGroups"];
      },
      set(permissionGroups) {
        this.$store.commit(
          "permissions/SET_PERMISSION_GROUPS",
          permissionGroups
        );
      },
    },
    permissionToEdit: {
      get() {
        return this.$store.getters["permissions/permissionToEdit"];
      },
      set(permissionToEdit) {
        this.$store.commit(
          "permissions/SET_PERMISSION_TO_EDIT",
          permissionToEdit
        );
      },
    },
  },
  created() {
    this.$store.dispatch("permissions/getPermissions").then((res) => {
      this.createFormattedPermission(res);
      // return roots;
    });
    this.$store.dispatch("permissions/getPermissionGroups");
     this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "permission", translate: true },
      { text: "permissions", to: { name: "permissions" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "permissions", to: { name: "permissions" }, translate: true },
    ]);
  },
};
</script>

<style lang="scss">
.permissions-tree {
  //font-size: 20px;
  .halo-tree li:before {
    //border-right: 2px dashed #999
  }

  .tree-box {
    background-color: white;
  }
}
</style>
